export default {
  s3: {
    REGION: "YOUR_S3_UPLOADS_BUCKET_REGION",
    BUCKET: "YOUR_S3_UPLOADS_BUCKET_NAME"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://pyt463ccmb.execute-api.us-east-1.amazonaws.com/prod"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_fWdDaI4Qn",
    APP_CLIENT_ID: "4bg4h61q8sf0dhc80vn29kf1fr",
    IDENTITY_POOL_ID: "us-east-1:a3cc485d-b512-444c-9c9f-db5295700d71"
  },
  social: {
    GOOGLE: "358364170622-htpd1b58d74gtbm8l79a3d59h53dlrjm.apps.googleusercontent.com"
  }
};



// WEBPACK FOOTER //
// ./src/config/aws.js